import { createContext } from "react";

export interface PointsContextType {
  points: number | null;
  loading: boolean;
  refreshPoints: () => Promise<void>;
  /**
   * Reconciles the balance with the authoritative total the feedback endpoint
   * already returns (`FeedbackResult.points`) — no local +/-5 guessing, no
   * delayed refetch. Called by FeedbackButtons right after it shows its own
   * "+N points" animation, so the two never diverge or double-count.
   */
  updatePointsAfterFeedback: (newTotal: number) => void;
}

export const PointsContext = createContext<PointsContextType | undefined>(undefined);
